<div class="collectionView">
  <div *ngIf="!sortedArtists" class="loadingContainer">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div *ngIf="sortedArtists">
    <div class="artistHeadingAndControlsContainer">
      <h2>Artists <small class="text-muted" data-ta-name="artistCount">({{sortedArtists.length}})</small></h2>
      <div class="artistViewControls">
        <div class="searchControls">
          <div class="input-group">
            <input type="search" class="form-control" placeholder="Search for artist" data-ta-name="artistSearchInput"
                   name="search-term" id="search-term" [(ngModel)]="searchText" (ngModelChange)="searchTextChanged($event)"/>
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
        <div class="dropdown" dropdown>
          <button type="button" class="btn btn-light dropdown-toggle" data-ta-name="artistSortButton" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" dropdownToggle>
            Sort By
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" (click)="sortAlphabetical()" href="javascript:void(0)" data-ta-name="sortByArtistName">
              <i class="fa fa-fw fa-check" *ngIf="artistSortViewIsAlphabetical()"></i>
              <i class="fa fa-fw" *ngIf="!artistSortViewIsAlphabetical()"></i>
              Artist name
            </a>
            <a class="dropdown-item" (click)="sortByMostAlbums()" href="javascript:void(0)" data-ta-name="sortByAlbumCount">
              <i class="fa fa-fw fa-check" *ngIf="artistSortViewIsAlbumCount()"></i>
              <i class="fa fa-fw" *ngIf="!artistSortViewIsAlbumCount()"></i>
              Album count (desc)
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="card-group">
      <div *ngFor="let artist of sortedArtists | filterByArtistName : searchTextForFiltering">
        <app-artist-card [artist]="artist"></app-artist-card>
      </div>
    </div>
  </div>
</div>
